import { configureStore } from '@reduxjs/toolkit';
import functionReducer from './Slice';

const store = configureStore({
  reducer: {
    functionStore: functionReducer
  }
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
